import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';

import { cardTypes } from 'apps/notificationCenter/index';

import Button from 'components/Button';
import Spinner from 'components/Spinner';

import Header from 'apps/components/header/header';

import styled from 'styled-components';
import { MainWrapper, Center } from 'legacyComponents/styled/lib';
import { Section } from 'legacyComponents/layout/section';
import { ButtonsWrapper } from 'apps/repository/styles';
import { FullPageWrapper } from 'apps/notificationCenter/styles';

@withNamespaces()
@inject('notificationCenter', 'headerStore')
@observer
export class NotificationsPage extends React.Component {
  UNSAFE_componentWillMount = () => {
    const { notificationCenter, headerStore } = this.props;
    notificationCenter.NewNotificationsQuery();
    headerStore.HideNotifDropdown();
  };

  render() {
    const { notificationCenter, t } = this.props;
    if (!notificationCenter.notifications) {
      return (
        <>
          <Header />
          <Spinner />
        </>
      );
    }
    const { notifications, MarkAllNotificationsAsRead } = notificationCenter;

    const actions = [
      <ButtonsWrapper key='0'>
        <Button
          text={<Trans>Mark All as Read</Trans>}
          size='small'
          onClick={() => MarkAllNotificationsAsRead()}
          outline
        />
      </ButtonsWrapper>,
    ];

    return (
      <>
        <Header />
        <MainWrapperStyled>
          <Section title={t('Your Notifications')} actions={actions}>
            <FullPageWrapper>
              {[...new Set(notifications)].map((notif, index) => {
                const Card = cardTypes[notif.type];
                const key = notif.id || `${notif.type}_${index}`;
                return <Card key={key} id={key} notification={notif} />;
              })}
              <Center>
                {notificationCenter.loading &&
                notificationCenter.notificationsConn.loadedMore ? (
                  <ButtonStyled
                    text={<Trans>Showing more...</Trans>}
                    loading
                    size='small'
                    onClick={() => notificationCenter.LoadMore()}
                  />
                ) : notificationCenter.loading ? (
                  <Spinner />
                ) : (
                  <ButtonStyled
                    text={<Trans>Show more</Trans>}
                    appearance='plain'
                    onClick={() => notificationCenter.LoadMore()}
                  />
                )}
              </Center>
            </FullPageWrapper>
          </Section>
        </MainWrapperStyled>
      </>
    );
  }
}

// FIXME: Move these styles to its styled file pending from notifications page
const ButtonStyled = styled(Button)`
  margin: ${props => `${props.theme.spacing.default} 0`};
`;

const MainWrapperStyled = styled(MainWrapper)`
  margin: ${props =>
    `${props.theme.spacing.medium} auto ${props.theme.spacing.large}`};
`;

NotificationsPage.propTypes = {
  notificationCenter: PropTypes.object,
  headerStore: PropTypes.object,
  t: PropTypes.func,
};
